import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-us-container">
      <h1>Contact Capronik</h1>
      <p>Page coming soon!</p>
    </div>
  );
};

export default Contact;
